<template>
  <v-row justify="center">
    <v-dialog v-model="active" persistent max-width="600">
      <v-card color="#FFF" style="box-shadow:none" align="center">
        <div class="pa-5 py-10">
          <v-row style="margin-top:3%; margin-left:2.2%">
            <div class="mx-5 firstBar"></div>
            <h4 style="font-size:26px">更新帳號資料</h4>
          </v-row>
          <v-row class="mt-2" justify="center">
            <v-col class="pa-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>國籍</div>
            </v-col>
            <v-col class="py-0 col-9 py-0 pt-1 pl-5">
              <v-radio-group class="ma-0 pa-0" dense v-model="datasets.citizenShip">
                <v-row>
                  <v-radio v-for="(data,index) in citizenShipList" :key="index" :value = "(index+1).toString()" class="pr-2" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">{{data.title}}</span>
                    </template>
                  </v-radio>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="mt-2" justify="center">
            <v-col class="pa-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>帳號</div>
            </v-col>
            <v-col class="py-0 col-8">
              <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入身分證或護照號碼" v-model="datasets.idCard"
              @keyup="datasets.idCard = datasets.idCard.replace(/[\u4e00-\u9fa5]/ig,'') && datasets.idCard.toUpperCase(), datasets.idCard = $Global.toCDB(datasets.idCard)"></v-text-field>
            </v-col>
            <v-col class="pa-0 pt-1 text-left col-1">
              <v-icon v-if="isIdCardOk" color="#81E285" size="30">mdi-check-all</v-icon>
              <v-icon v-else color="#E28181" size="30">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="pa-0 col-2">
              <div class="text-right pt-3 pt14"><span class="start">*</span>密碼</div>
            </v-col>
            <v-col class="py-0 col-8">
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y left min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="請選擇"
                    v-model="datasets.birthday" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker ref="picker" v-model="datasets.birthday" no-title scrollable
                  :max="new Date().toISOString().substr(0, 10)" :picker-date="pickerDate" @change="$refs.menu.save(datasets.birthday)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="pa-0 pt-1 text-left col-1">
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="pa-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>再次輸入密碼</div>
            </v-col>
            <v-col class="py-0 col-8">
              <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入出生年月日" v-model="birthdayAgain"
              @keyup="birthdayAgain = $Global.toCDB(birthdayAgain)"></v-text-field>
            </v-col>
            <v-col class="pa-0 pt-1 text-left col-1">
              <v-icon v-if="isBirthdayAgainMatch" color="#81E285" size="30">mdi-check-all</v-icon>
              <v-icon v-if="!isBirthdayAgainMatch" color="#E28181" size="30">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="pa-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
            </v-col>
            <v-col class="col-8 py-0">
              <email-auto-complete ref="EmailAutoComplete" :onCompletion='(val) => datasets.email = val' :domains='mailCandidateList'>
                <input class="emailAutoComplete" type="text" placeholder="請輸入電子信箱" v-model='datasets.email'
                @keyup="[$refs.EmailAutoComplete.check($event), datasets.email= datasets.email.replace(/[\u4e00-\u9fa5]/ig,''), datasets.email = $Global.toCDB(datasets.email)]" />
              </email-auto-complete>
            </v-col>
            <v-col class="pa-0 pt-1 text-left col-1">
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="pa-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>通訊地址</div>
            </v-col>
            <v-col class="py-0 col-8">
              <v-row v-if="datasets.citizenShip == '1'">
                <v-select class="text_field px-3 col-12 col-lg-6" dense background-color="white" outlined placeholder="請選擇縣市" :items="countryList" item-text="country" item-value="country" style="width:48%" v-model="datasets.country"></v-select>
                <v-select class="text_field px-3 col-12 col-lg-6" dense background-color="white" outlined placeholder="請選擇行政區" :items="areaList" item-text="area" item-value="area" style="width:48%" v-model="datasets.area"></v-select>
              </v-row>
              <v-row>
                <v-text-field class="border pt14 px-3" dense background-color="white" outlined placeholder="請輸入詳細地址" v-model="datasets.address"
                @keyup="datasets.address = $Global.toCDB(datasets.address)"></v-text-field>
              </v-row>
            </v-col>
            <v-col class="pa-0 pt-1 text-left col-1">
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="pa-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>學校類別</div>
            </v-col>
            <v-col class="py-0 col-8">
              <v-row class="px-3">
                <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇學校類別" :items="collegeCategoryList" item-text="title" item-value="valuev" v-model="datasets.collegeCategory"></v-select>
              </v-row>
            </v-col>
            <v-col class="pa-0 pt-1 text-left col-1">
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="pa-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>學校/單位</div>
            </v-col>
            <v-col class="py-0 col-8">
              <v-row class="px-3">
                <v-autocomplete v-if="datasets.collegeCategory!='4'" class="border pt14 autocomplete" placeholder="請選擇學校/單位" 
                :items="schoolList" item-text="name" item-value="name" v-model="datasets.company"></v-autocomplete>
                <v-text-field v-if="datasets.collegeCategory=='4'" class="text_field" dense background-color="white" outlined placeholder="請輸入單位名稱" v-model="datasets.company"></v-text-field>
              </v-row>
            </v-col>
            <v-col class="pa-0 pt-1 text-left col-1">
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="pa-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
            </v-col>
            <v-col class="py-0 col-8">
              <v-row class="px-3">
                <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入系所/部門" v-model="datasets.department"
                @keyup="datasets.department = $Global.toCDB(datasets.department)"></v-text-field>
              </v-row>
            </v-col>
            <v-col class="pa-0 pt-1 text-left col-1">
            </v-col>
          </v-row>
          <v-row class="mt-1" justify="center">
            <v-btn class="ma-1 loginBack col-9" outlined style="height:40px; background:#81c0e2; border-radius:8px; border:none" @click="setDatasets()">
              <span style="color:#FFFFFF">送出</span>
            </v-btn>
            <!-- <v-btn class="ma-1 loginBtn col-9 col-sm-4 col-md-4 col-lg-4" outlined style="height:40px; background:#969698; border-radius:8px; border:none"  @click="close">
              <span style="color:#FFFFFF">下次更新</span>
            </v-btn> -->
          </v-row>
          <v-row justify="center">
            <v-col class="px-1 text-left col-10 col-sm-9" style="line-height:1">
              <span style="font-size:9pt">*提醒您，身分證字號為後續登入帳號唯一值，西元出生年月日為密碼。避免後續無法登入，請勿填寫假資訊，謝謝您。</span>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
  </v-row>
</template>

<script>
  import CryptoJS from "crypto-js"
  import EmailAutoComplete from "vue-email-autocomplete";
  import moment from 'moment'
  import ShowMsg from '@/dialogs/ShowMsg'
  export default {
    name:'NewMemberInformation',
    components: {EmailAutoComplete,ShowMsg},
    mounted(){
      this.$Global.getCitizenShipList().then(res=>{ this.citizenShipList = res })
      this.$Global.getCountryList().then(res=>{ this.countryList = res })
      this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res })
      this.$Global.getMailCandidateList().then(res=>{ this.mailCandidateList = res })
    },
    data () {
      return {
        memberId: '',
        active: false,
        datasets: [],
        menu: false,
        pickerDate:(new Date().getFullYear()-20) + '-1-1',
        birthdayAgain:'',
        isIdCardOk:false,
        requiredField:['citizenShip','idCard','birthday','collegeCategory','company','department','address'],
        requiredFieldOther:['zipCode','country','area'],
        
        mailCandidateList: [],
        citizenShipList: [],
        countryList: [],
        areaList: [],
        collegeCategoryList: [],
        schoolList: [],
      }
    },
    watch:{
      menu (val) {
        val && setTimeout(() => (
          this.$refs.picker.activePicker = 'YEAR',
          this.pickerDate = null
        ))
      },
      "datasets.citizenShip":function(){
        this.datasets.idCard = ''
      },
      "datasets.idCard":function(){
        if(this.datasets.citizenShip == '1'){
          if(this.datasets.idCard.length == 10){
            this.datasets.idCard = this.datasets.idCard.toUpperCase();
            this.$Global.checkIdCard(this.datasets.idCard).then(res=>{ this.isIdCardOk = res })
            this.$Global.getIdCardInfo(this.datasets.idCard).then(res=>{ this.idCardInfo = res })
            return
          }
          this.isIdCardOk = false
        }
        if(this.datasets.citizenShip == '2'){
          if(this.datasets.idCard.length > 5 && this.datasets.idCard.length <= 18){
            this.$Global.checkChinaIdCard(this.datasets.idCard).then(res=>{ this.isIdCardOk = res })
            this.$Global.getIdCardInfo(this.datasets.idCard).then(res=>{ this.idCardInfo = res })
            return
          }
          this.isIdCardOk = false
        }
        if(this.datasets.citizenShip == '3'){
          if(this.datasets.idCard.length > 5 && this.datasets.idCard.length <= 20){
            this.$Global.checkPassport(this.datasets.idCard).then(res=>{ this.isIdCardOk = res })
            this.$Global.getIdCardInfo(this.datasets.idCard).then(res=>{ this.idCardInfo = res })
            return
          }
          this.isIdCardOk = false
        }
      },
      "datasets.country":function(){
        this.$Global.getAreaListByCountryList(this.datasets.country).then(res=>{ this.areaList = res })
      },
      "datasets.collegeCategory":function(){
        this.$Global.getSchoolList(this.datasets.collegeCategory, true).then(res=>{ this.schoolList = res })
      },
      "datasets.area":function(){
        this.datasets.zipCode = this.$Global.getZipCode(this.areaList, this.datasets.area, this.datasets.zipCode)
      },
    },
    computed:{
      isBirthdayAgainMatch () {
        return this.datasets.birthday == this.birthdayAgain
      },
    },
    methods:{
      open(data){
        this.active = true
        this.memberId = data
        this.getDatasets()
      },
      close(){
        this.active = false
      },
      save(){
        this.close()
      },
      jsonConcat(o1, o2){
        for (var key in o2) {
          o1[key] = o2[key];
        }
        return o1;
      },
      redirectPath(path){
        this.$router.push(path).catch(err => {})
      },
      allowedDates(val){
        let dateMax = moment().add(0, 'days').format('YYYY-MM-DD')
        return (new Date(val) <= new Date(dateMax))
      },
      getDatasets(){
        var self = this
        var request = {
          method: 'GET',
          url: '/erpTeacher/' + this.memberId,
          params: {},
        }
        this.$http(request).then(function(response) {
          self.datasets = response.data.data
        }).catch(()=>{
        }).finally(()=>{
          self.datasets.citizenShip = '1'
          self.datasets.email = self.datasets.memberId
        })
      },
      setDatasets(){
        if(!this.isIdCardOk){
          this.$refs.ShowMsg.open(0,'帳號錯誤','請輸入您的身分證字號')
          return
        }
        if(this.idCardInfo.erpTeacher || this.idCardInfo.erpMember){
          this.$refs.ShowMsg.open(0,'身分衝突','該"身分證字號/護照號碼"已經有帳號，請聯絡學會專員進行身分確認。')
          return
        }
        if(!this.isBirthdayAgainMatch){
          this.$refs.ShowMsg.open(0,'密碼不相符','請輸入您的生日當作預設密碼，且需包含-符號')
          return
        }
        if(!this.$Global.checkForm(this.datasets,this.requiredField)){
          this.$refs.ShowMsg.open(1)
          return
        }
        if(this.datasets.citizenShip=='1' || !this.datasets.citizenShip){
          if(!this.$Global.checkForm(this.datasets,this.requiredFieldOther)){
            this.$refs.ShowMsg.open(1)
            return
          }
        }
        var allData = this.datasets
        allData = this.jsonConcat(allData,{'updateId' : this.datasets.idCard})
        allData = this.jsonConcat(allData,{'memberId' : this.datasets.idCard})
        allData = this.jsonConcat(allData,{'passwd' : CryptoJS.MD5(this.datasets.birthday).toString()})

        var self = this
        var request = {
          method: 'PUT',
          url: '/erpTeacher',
          data: this.Qs.stringify(allData)
        }
        this.$http(request).then(function(response) {
          // console.log(response)
          self.$refs.ShowMsg.open(0,'帳號資料更新完成','請以新帳號資料為預設登入本系統，謝謝。',true,true)
        }).catch(()=>{
        }).finally(()=>{
        })
      },
      
      send(){
        if(!this.isIdCardOk){
          this.$refs.ShowMsg.open(0,'帳號錯誤','請輸入您的身分證字號')
          return
        }
        if(!this.isBirthdayAgainMatch){
          this.$refs.ShowMsg.open(0,'密碼不相符','請輸入您的生日當作預設密碼，且需包含-符號')
          return
        }
        console.log('send')
        // var allData = this.datasets
        // allData = this.jsonConcat(allData,{'memberType' : 'erpTeacher'})
        // allData = this.jsonConcat(allData,{'memberId' : this.datasets.idCard})
        // allData = this.jsonConcat(allData,{'passwd' : this.datasets.birthday})
        // var self = this
        // var request = {
        //   method: '_POST',
        //   url: '/common/erpTeacher',
        //   data: this.Qs.stringify(allData)
        // }
        // this.$http(request).then(function(response) {
        //   // console.log(response)
        //   //dialog // TBD
        //   //this.$refs.ChangePassword.open()
        // }).catch(()=>{
        //   //this.$refs.ChangePassword.open()
        // })
      },
      onShowMsg(){
        // this.close()
        this.redirectPath('/login')
      },
    }
  }
</script>